<h3 class="my-4">Sammanställd antibiotikaresistens</h3>
<div *ngIf="loading" style="margin-bottom: 10rem; text-align: center;">
  <div class="mb-4">Sammanställer antibiotikaresistens. Var god vänta...</div>
  <p-progressSpinner></p-progressSpinner>

</div>
<div *ngIf="!loading" class="resistance-table">
  <p-table
    [value]="calcData || []"
    [tableStyle]="{ 'min-width': '50rem' }"
    [columns]="tableConfig.columns"
    [rowHover]="true"
    [sortMode]="'multiple'"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th></th>
        <th colspan="7" class="border-left">SIR</th>
        <th colspan="7" class="border-left">Tolkning MIC</th>
      </tr>
      <tr>
        <th
          [pSortableColumn]="col.sortByField"
          style="border-radius: 0"
          *ngFor="let col of columns; let i = index"
          [class.border-left]="i === 1 || i === 8"
        >
          {{ col.header }}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-columns="columns" let-antibiotic let-rowIndex="rowIndex">
      @if (loading) {
        <ng-container [ngTemplateOutlet]="loadingRow" />
      } @else {
        <tr [class.stripe]="rowIndex % 2 !== 0">
          <td *ngFor="let col of columns; let i = index" [class.border-left]="i === 1 || i === 8">
            {{ antibiotic[col.field!] }}
          </td>
        </tr>
      }
    </ng-template>
    <ng-template #loadingRow>
      <tr *ngFor="let i of [].constructor(1)">
        <td *ngFor="let j of [].constructor(15)"><p-skeleton /></td>
      </tr>
    </ng-template>
  </p-table>
</div>
